import { render } from "./NoFavorites.vue?vue&type=template&id=8f843fce&scoped=true&ts=true&lang=pug"
import script from "./NoFavorites.vue?vue&type=script&lang=ts"
export * from "./NoFavorites.vue?vue&type=script&lang=ts"

import "./NoFavorites.vue?vue&type=style&index=0&id=8f843fce&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./NoFavorites.vue?vue&type=custom&index=0&blockType=i18n&locale=en"
if (typeof block0 === 'function') block0(script)
import block1 from "@/locale/es/favorite/noFavorites.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Ftarball%2Fsrc%2Fcomponents%2Ffavorite%2FNoFavorites.vue&locale=es"
if (typeof block1 === 'function') block1(script)


import exportComponent from "/tarball/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f843fce"]])

export default __exports__